import React, {useState, useRef, useCallback, useEffect} from 'react'
import { useEventListener } from 'react-recipes'
import slugify from 'slugify'

import Anchors from './anchors'

const AnchorsContent = ({children, sections, isOffer = false}) => {
  const [isSticky, setIsSticky] = useState(false)
  const [isBottomed, setIsBottomed] = useState(false)
  const [activeItem, setActiveItem] = useState(null)
  const [activeItemTitle, setActiveItemTitle] = useState(null)

  const anchorsWrapper = useRef(null)
  const contentWrapper = useRef(null)
  const sectionsDOM = useRef()

  const scrollHandler = useCallback(
    () => {
      const offsetBottom = anchorsWrapper.current.getBoundingClientRect().top + anchorsWrapper.current.offsetHeight - 200 - anchorsWrapper.current.querySelector('.anchors').offsetHeight

      // set sticky or is bottomed
      if (anchorsWrapper.current) {
        if (window.innerWidth >= 1024) {
          setIsSticky(anchorsWrapper.current.getBoundingClientRect().top <= 200 && offsetBottom >= 0)
          setIsBottomed(offsetBottom < 0)
        } else {
          const headerOffset = window.innerWidth >= 768 ? 104 : 64
          setIsSticky(contentWrapper.current.getBoundingClientRect().top <= headerOffset + 64)
        }
      }

      // set activeItem
      sectionsDOM.current.forEach(section => {
        // 109 = 77 of header height + 32 of breathing on anchors for mobile // 182 for desktop with header at 150
        if (section.getBoundingClientRect().top < (window.innerWidth < 1024 ? window.innerWidth < 768 ? 109 : 194 : 182)) {
          setActiveItem(section.id)
          setActiveItemTitle(section.dataset.anchor)
        }
      })
    }, []
  )
  useEventListener("scroll", scrollHandler)

  useEffect(() => {
    setActiveItem(slugify(sections[0], {remove: /[*+~.,()'"!?:@,]/g}).toLocaleLowerCase())
    setActiveItemTitle(sections[0])

    sectionsDOM.current = document.querySelectorAll('.slice')
  }, [sections])

  return (
    <div className="row">
      <div className="col-12 lg-col-3 xl-col-2 flex" ref={anchorsWrapper}>
        <div className="relative w-full">
          <Anchors
            sections={sections}
            isSticky={isSticky}
            isBottomed={isBottomed}
            activeItem={activeItem}
            activeItemTitle={activeItemTitle}
            isOffer={isOffer}
          />
        </div>
      </div>
      <div className={`col-12 lg-col-9 xl-col-offset-1 ${isOffer ? 'is-offer' : ''}`} ref={contentWrapper}>
        {children}
      </div>
    </div>
  )
}

export default AnchorsContent